import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FlyoutDataType, FlyoutOpeningData, PersonalData, PersonDetails, SessionDetails } from '../flyout-models';
import { Subscription } from 'rxjs';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-contact-information',
  templateUrl: './flyout-contact-information.component.html',
  styleUrls: ['./flyout-contact-information.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutContactInformationComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private _openingData: FlyoutOpeningData;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public FlyoutDataTypes = FlyoutDataType;
  public personalData = undefined as PersonalData;
  public customProperties: any;

  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this._openingData = openingData;
    this.processData();
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutContactInformationComponent');
  }

  ngOnInit() {
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
      this.processData();
    });
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
      this.processData();
    });
  }

  private processData() {
    let personalData = undefined,
      customProperties = undefined;
    if (this._openingData.type === FlyoutDataType.Contact && this.personDetails) {
      personalData = this.personDetails.personalData;
      customProperties = this.personDetails.properties;
    } else if (this._openingData.type === FlyoutDataType.Session && this.sessionDetails) {
      personalData = this.sessionDetails.personalData;
      customProperties = this.sessionDetails.properties;
    }
    this.personalData = personalData;
    this.customProperties = this.modifyToObject(this.cleanupCustomProperties(customProperties));
  }

  private cleanupCustomProperties(customProperties) {
    if (customProperties) {
      customProperties = Object.fromEntries(
        Object.entries(customProperties).filter(([key, _val]) => key !== 'responseListId' && key !== 'submitPath'),
      );
    }
    return customProperties;
  }

  public modifyToObject(customProperties) {
    if (!customProperties) {
      return undefined;
    }
    return Object.entries(customProperties).map(([key, value]) => ({
      key,
      value,
      displayName: key.toLowerCase() === 'voyadocontactid' ? 'flyout.contact-info.voyadocontactid' : null,
    }));
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.personSubscription, this.sessionSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
